// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__wwB-n","overflowing":"ReadFullNote_overflowing__33LZ2"};